import * as React from "react";

function SvgStar(props) {
  return <svg width={12} height={12} viewBox="0 0 12 12" fill="currentColor" stroke="currentColor" {...props}><path d="M6.115 9.148L6 9.088l-.115.06-3.26 1.697.621-3.59.023-.131-.095-.092L.54 4.49l3.64-.524.13-.018.059-.118L6 .561l1.63 3.27.059.118.13.018 3.64.524-2.633 2.54-.095.093.023.13.622 3.591-3.26-1.697z" strokeWidth={0.5} /></svg>;
}

export default "//cdn.scentbird.com/assets/frontbird-site/images/star_6a124e.svg";
export { SvgStar as ReactComponent };